import { render } from "./ProyectoEstado.vue?vue&type=template&id=46293930&scoped=true"
import script from "./ProyectoEstado.vue?vue&type=script&lang=js"
export * from "./ProyectoEstado.vue?vue&type=script&lang=js"

import "./ProyectoEstado.vue?vue&type=style&index=0&id=46293930&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46293930"]])

export default __exports__